import Vue from 'vue'
import App from './App.vue'
import router from '@/routes/router.js'
import store from './store/store'
import '@/assets/js/snappyjs.min'

//for theme
import './plugins/element.js'
import './plugins/theme.js'
import './plugins/http.js'
import './plugins/mixins.js'
import './plugins/devLog.js'
import gAuth from './plugins/google.js'

window.gAuth = gAuth

import './plugins/plugin'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

